export enum CurrentTheme {
  Light = 'light',
  Dark = 'dark',
}
